<template>
    <router-link :to="url" class="flex items-center text-22  ml-2 mr-4">
        <slot></slot>
        <div class="ml-2" :class="[textColor]">{{label}}</div>
    </router-link>
</template>
<script>
export default {
    name: 'MenuItem',
    props: {
        isActive: Boolean,
        label: String,
        url: String,
    },
    computed: {
        textColor: function() {
            if (this.isActive) {
                return 'text-tc-blue-1';
            }
            return 'text-tc-gray-1';
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
